// extracted by mini-css-extract-plugin
module.exports = {"number-box":"number-box-20PvGOVVATvZjVlmSbhcsQ","numberBox":"number-box-20PvGOVVATvZjVlmSbhcsQ"};